import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent, DxSchedulerComponent} from 'devextreme-angular';
import {MatListOption} from '@angular/material/list';
import {NonWorkingDaysService} from '../../../services/configuration/non-working-days.service';
import {WorkRegionModel} from '../../../models/configuration/nonWorkingDays/work-region.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {MatTableDataSource} from '@angular/material/table';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {MatDialog} from '@angular/material/dialog';
import {NonWorkingDayModel} from '../../../models/configuration/nonWorkingDays/non-working-day.model';
import {NonWorkingDaysModel, NonWorkingYearModel} from '../../../models/configuration/nonWorkingDays/non-working-days.model';
import {DialogService} from '../../../services/dialog.service';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {Constants} from '../../../constants';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfigurationService} from '../configuration.service';

const _nonWorkingDayTextLabel: string = 'No Work'; 

export class RegionTableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  RegionName: string;
  WorkRegionID: string;
  
  actions = [TdoTableActionsEnum.DELETE];
  model: WorkRegionModel;

  getActionTooltip(actionName: string): string {
    switch (actionName) {
      case TdoTableActionsEnum.DELETE:
        return `Delete ${this.RegionName}`;
        break;
    }
  }
}

export class YearTableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  NonWorkingYear: number;
  model: NonWorkingYearModel;

  getActionTooltip(actionName: string): string {
    return '';
  }
}

@Component({
  selector: 'app-non-working-days',
  templateUrl: './non-working-days.component.html',
  styleUrls: ['./non-working-days.component.css']
})
export class NonWorkingDaysComponent implements OnInit, AfterViewInit {
  @ViewChild('regionTable') regionTable: TdoTableComponent;
  @ViewChild('yearTable') yearTable: TdoTableComponent;

  constructor(private nonWorkingDaysService: NonWorkingDaysService,
              private dialogService: DialogService,
              private changeDetectorRef: ChangeDetectorRef,
              private snackbar: MatSnackBar,
              public configurationService: ConfigurationService,
              private dialog: MatDialog) {
    //
  }
  isLoading = true;
  addingNew: boolean = false;
  newRegionName: string = '';

  nonWorkingDays: NonWorkingDaysModel;

  regionList: WorkRegionModel[] = [];
  selectedRegion: WorkRegionModel;
  selectedYear: number = -1;
  minDate: Date;
  maxDate: Date;

  schedulerDataSource: any[] = [];
  countryValue : string ='';


  regionTableModel: TdoTableModel;
  regionTableDataSource: MatTableDataSource<RegionTableViewData>;
  regionTableViewData: RegionTableViewData[];
  regionDisplayedColumns = ['RegionName', 'actions'];
  regionDisplayedColumnsLabels = ['Region Name'];

  yearTableModel: TdoTableModel;
  yearTableDataSource: MatTableDataSource<YearTableViewData>;
  yearTableViewData: YearTableViewData[];
  yearDisplayedColumns = ['NonWorkingYear'];
  yearDisplayedColumnsLabels = ['Year'];

  isRecurringExisted = false;
  recurringDaysPerSelectedYear: NonWorkingDayModel;
  yearsList: NonWorkingDayModel[] = [];

  @ViewChild(DxDataGridComponent) regionGrid: DxDataGridComponent;
  @ViewChild(DxDataGridComponent) yearGrid: DxDataGridComponent;
  @ViewChild('scheduler') scheduler: DxSchedulerComponent;

  private timeoutCellClick: NodeJS.Timer;

  public ngOnInit() {

  }

  public ngAfterViewInit() {
    this.getNonWorkingDayData();
  }

  private async getNonWorkingDayData() {
    try {
      this.nonWorkingDaysService.getScheduleNonWorkingRegions().subscribe((data) => {
        this.regionList = data;
        if (this.regionList && this.regionList.length > 0) {
          this.selectedRegion = this.regionList[0];
          this.nonWorkingDaysService.getYears(this.selectedRegion.WorkRegionID).subscribe((years) => {
            this.yearsList = years;
            this.selectedYear = this.yearsList[0].NonWorkingYear;
            this.minDate = new Date(this.selectedYear, 0, 1);
            this.maxDate = new Date(this.selectedYear, 11, 31);
            this.refreshYearTableView();
            this.isLoading = false;

            const tvd = new RegionTableViewData();
            tvd.model = this.selectedRegion;
            this.onTdoRegionTableItemClick(new TdoTableEvent(tvd), true);
          });
        }
        this.refreshRegionTableView();
      });
    } catch (exception) {
      console.log(exception);
    }
  }

  refreshRegionTableView() {
    this.regionTableViewData = Array.from(this.regionList, _ => {
      const model = new RegionTableViewData();
      model.RegionName = _.RegionName;
      model.WorkRegionID = _.WorkRegionID;
      model.model = _;
      return model;
    });

    if (!this.regionTableModel) {
      this.regionTableDataSource = new MatTableDataSource<RegionTableViewData>(this.regionTableViewData);
      this.regionTableModel = new TdoTableModel(this.regionDisplayedColumns, this.regionDisplayedColumnsLabels, this.regionTableDataSource);
      setTimeout(() => {
        this.regionTable.selection.select(this.regionTableDataSource.data[0]);
      }, 500);
    } else {
      (this.regionTableDataSource as MatTableDataSource<RegionTableViewData>).data = this.regionTableViewData;
      (this.regionTableDataSource as MatTableDataSource<RegionTableViewData>)._updateChangeSubscription();
    }
  }

  refreshYearTableView() {
    this.yearTableViewData = Array.from(this.yearsList, _ => {
      const model = new YearTableViewData();
      model.NonWorkingYear = _.NonWorkingYear;
      model.model = _;
      return model;
    });

    if (!this.yearTableModel) {
      this.yearTableDataSource = new MatTableDataSource<YearTableViewData>(this.yearTableViewData);
      this.yearTableModel = new TdoTableModel(this.yearDisplayedColumns, this.yearDisplayedColumnsLabels, this.yearTableDataSource);
      setTimeout(() => {
        this.yearTable.selection.select(this.yearTableDataSource.data[0]);
      }, 500);
    } else {
      (this.yearTableDataSource as MatTableDataSource<YearTableViewData>).data = this.yearTableViewData;
      (this.yearTableDataSource as MatTableDataSource<YearTableViewData>)._updateChangeSubscription();
    }
  }

  onTdoRegionTableItemActionClick(event: TdoTableEvent) {
    switch (event.action) {
      case TdoTableActionsEnum.DELETE:
        const model = (event.value as RegionTableViewData).model;
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.RegionName}?`).subscribe((result) => {
          if (result === true) {
            this.nonWorkingDaysService.deleteRegion(model).subscribe((val) => {
              const idx = this.regionList.findIndex(p => p.WorkRegionID === model.WorkRegionID);
              if (idx > -1) {
                this.regionList.splice(idx, 1);
                this.selectedRegion = this.regionList[0];
                const tvd = new RegionTableViewData();
                tvd.model = this.selectedRegion;
                this.refreshRegionTableView();
                this.onTdoRegionTableItemClick(new TdoTableEvent(tvd), true);
              }
            });
          } else {
            //
          }
        });
    }
  }

  onTdoRegionTableItemClick(event: TdoTableEvent, isAutomated = false) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeRegion((event.value as RegionTableViewData).model);
          return;
        } else {
          // Select proor // TODO: Change to new tdo table
        }
      });
    } else {
      this.changeRegion((event.value as RegionTableViewData).model);
    }
  }

  changeRegion(region: WorkRegionModel) {
    this.selectedRegion = region;

    this.nonWorkingDaysService.getYears(this.selectedRegion.WorkRegionID).subscribe((years) => {
      this.yearsList = years;
      this.selectedYear = this.yearsList[0].NonWorkingYear;
      this.refreshYearTableView();
    });

    this.addingNew = false;

    try {
      this.nonWorkingDaysService.getScheduleNonWorking(this.selectedRegion.WorkRegionID).subscribe((response) => {
        this.nonWorkingDays = new NonWorkingDaysModel(response.cfgScheduleNonWorkingDays);

        if (this.scheduler) {
          this.schedulerDataSource = this.nonWorkingDays.toScheduleDataSource(this.selectedYear);
          this.countryValue =  this.nonWorkingDays.enumCountryID;
        }
      });
    } catch (exception) {
      console.log(exception);
    }
  }

  onTdoYearTableItemClick(event: TdoTableEvent) {
    const model = (event.value as YearTableViewData).model;
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeYear(model);
          return;
        } else {
          // Select proor // TODO: Change to new tdo table
        }
      });
    } else {
      this.changeYear(model);
    }
  }

  changeYear(year: NonWorkingYearModel) {
    this.selectedYear = year.NonWorkingYear;
    this.initScheduler();
    this.minDate = new Date(this.selectedYear, 0, 1);
    this.maxDate = new Date(this.selectedYear, 11, 31);
    this.recurringDaysPerSelectedYear = this.nonWorkingDays.cfgScheduleNonWorkingDays.find(p => p.RecurringDays !== null && p.NonWorkingYear === this.selectedYear);
    if (!this.recurringDaysPerSelectedYear) {
      this.recurringDaysPerSelectedYear = new NonWorkingDayModel(null, this.selectedRegion.WorkRegionID, this.selectedYear, null, '');
    }
  }

  public onNew(event: Event): void {
    this.addingNew = true;

    this.selectedRegion = null;

    this.regionGrid.instance.clearSelection();
    this.yearGrid.instance.clearSelection();
  }

  public onDuplicate(event: Event): void {
    window.alert('not implemented');
  }

  // Had to do this because the scheduelr is in a ngIf
  // Also had to use the setTimeout because it was giving a weird error.
  public initScheduler(): void {
    /*this.changeDetectorRef.detectChanges();
    this.schedulerDataSource = this.nonWorkingDays.toScheduleDataSource(this.selectedYear);
    console.log('test');*/
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
      this.schedulerDataSource = this.nonWorkingDays.toScheduleDataSource(this.selectedYear);
      this.countryValue =  this.nonWorkingDays.enumCountryID;
    }, 500);
  }

  public onYearSelectionChanged(e): void {
    if (e.selectedRowsData.length > 0) {
      this.selectedYear = e.selectedRowsData[0].NonWorkingYear;

      this.minDate = new Date(this.selectedYear, 0, 1);
      this.maxDate = new Date(this.selectedYear, 11, 31);
    }
  }

  public async onSaveNewRegion(): Promise<void> {
    this.selectedYear = -1;
    if (this.newRegionName.trim() === '') {
      return;
    }

    try {
      this.nonWorkingDaysService.createScheduleNonWorking(this.newRegionName).subscribe((result) => {
        this.regionList.push(new WorkRegionModel(result.WorkRegionID, this.newRegionName));
        this.refreshRegionTableView();
        this.onCancelNewRegion();
        this.newRegionName = '';
      });
    } catch (e) {
      console.log(e);
    }
  }

  public onCancelNewRegion(): void {
    this.addingNew = false;
    this.newRegionName = '';

    this.selectedRegion = null;

    this.regionGrid.instance.clearSelection();
    this.yearGrid.instance.clearSelection();
  }

  public onNewYear(event): void {
    if (this.selectedRegion == null || this.nonWorkingDays == null) {
      return;
    }

    let highestYear = 0;
    for (const year of this.yearsList) {
      if (year.NonWorkingYear > highestYear) {
        highestYear = year.NonWorkingYear;
      }
    }

    const newYear = new NonWorkingDayModel(Constants.emptyGuid, this.selectedRegion.WorkRegionID, highestYear + 1);
    //newYear.NonWorkingYear = highestYear + 1;

    this.nonWorkingDaysService.saveYears([newYear]).subscribe((res) => {
      if (res && res.length > 0) {
        this.yearsList.push(res[0]);
        this.refreshYearTableView();
      }
    });
    /*this.nonWorkingDays.YearList.push(newYear);
    this.nonWorkingDays.AddEmptyYear();*/

  }

  getIsCommonDaySelected(dayName: string) {
    if (this.recurringDaysPerSelectedYear && this.recurringDaysPerSelectedYear.RecurringDays) {
      const arr = this.recurringDaysPerSelectedYear.RecurringDays.split(',');
      const dayNum = this.getDayNumFromWord(dayName);
      if (arr.includes(dayNum)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getDayNumFromWord(dayName: string) {
    const name = dayName.toLowerCase();
    switch (name) {
      case 'sunday':
        return '0';
      case 'monday':
        return '1';
      case 'tuesday':
        return '2';
      case 'wednesday':
        return '3';
      case 'thursday':
        return '4';
      case 'friday':
        return '5';
      case 'saturday':
        return '6';
    }
  }

  changeRecurringDays(options: MatListOption[]) {
    const source = options;

    const arr: string[] = [];
    for (const obj of source) {
      arr.push(this.getDayNumFromWord(obj.value));
    }
    this.recurringDaysPerSelectedYear.RecurringDays = arr.toString();
    console.log('test');
  }

  public addCommonNonWorkingDays(selectedOptions: MatListOption[]) {
    if (selectedOptions == null || selectedOptions.length < 1) {
      return;
    }

    this.changeRecurringDays(selectedOptions);

    // convert into map
    const daysOfWeeks: Set<string> = new Set(selectedOptions.map(o => o.value));


    const listOfFirstRecurringDayOfWeekInTheYear: any[] = [];

    // we really only need to go for a week (7 days)
    for (let i = 1; i <= 7; i++) {
      const newDate = new Date(this.selectedYear, 0, i);
      let match: boolean = false;
      let byDay: string = '';

      if (newDate.getDay() === 0 && daysOfWeeks.has('Sunday')) {
        match = true;
        byDay = 'SU'; // specific string for the dxScheduler
      }
      else if (newDate.getDay() === 1 && daysOfWeeks.has('Monday')) {
        match = true;
        byDay = 'MO';
      }
      else if (newDate.getDay() === 2 && daysOfWeeks.has('Tuesday')) {
        match = true;
        byDay = 'TU';
      }
      else if (newDate.getDay() === 3 && daysOfWeeks.has('Wednesday')) {
        match = true;
        byDay = 'WE';
      }
      else if (newDate.getDay() === 4 && daysOfWeeks.has('Thursday')) {
        match = true;
        byDay = 'TH';
      }
      else if (newDate.getDay() === 5 && daysOfWeeks.has('Friday')) {
        match = true;
        byDay = 'FR';
      }
      else if (newDate.getDay() === 6 && daysOfWeeks.has('Saturday')) {
        match = true;
        byDay = 'SA';
      }

      if (match) {
        listOfFirstRecurringDayOfWeekInTheYear.push({
          date: new Date(this.selectedYear, 0, i),
          byDay
        });
      }
    }

    listOfFirstRecurringDayOfWeekInTheYear.forEach(o => {
      // don't same days
      /*if (this.scheduler.instance.getDataSource().items().some(p => new Date(p.startDate).getTime() === o.date.getTime())) {
        return;
      }*/

      this.scheduler.instance.addAppointment({
        text: _nonWorkingDayTextLabel,
        startDate: o.date,
        endDate: new Date(o.date.getFullYear(), o.date.getMonth(), o.date.getDate() + 1),
        allDay: true,
        recurrenceRule: `FREQ=WEEKLY;BYDAY=${o.byDay};UNTIL=${this.selectedYear}${12}${31}`
      });
    });

    console.log(this.schedulerDataSource);
    console.log(this.scheduler.appointmentCollectorTemplate);
    console.log('test');
  }

  onCountrySelected( event)  {
    
    console.log( 'country changed ', event )
    this.selectedRegion.enumCountryID = event.ValidValueItemId ; 
    this.onSaveNonWorkingDays();



  }


  public async onSaveNonWorkingDays(): Promise<void> {
    const nonWorkingDaysToAdd = this.scheduler.instance.getDataSource().items() as any[];

     {
      try {

        // WHY DUPLICATES?
        const convertedNonWorkingDays: NonWorkingDayModel[] = nonWorkingDaysToAdd.map(o => o.model);
        // Find the null object injected when creating the recurring
        /*const nullIdx = convertedNonWorkingDays.findIndex(o => o === undefined);
        if (nullIdx > -1) {
          convertedNonWorkingDays[nullIdx] = this.recurringDaysPerSelectedYear;
        } else {
          const modelIdx = convertedNonWorkingDays.findIndex(p => p.RecurringDays !== null);
          if (modelIdx > -1) {
            convertedNonWorkingDays[modelIdx] = this.recurringDaysPerSelectedYear;
          } else {
            convertedNonWorkingDays.push(this.recurringDaysPerSelectedYear);
          }
        }*/

        console.log('saving 4 .... ')
        this.nonWorkingDaysService.updateScheduleNonWorkingDay(this.selectedRegion.WorkRegionID, this.selectedRegion.enumCountryID , this.nonWorkingDays.cfgScheduleNonWorkingDays).subscribe((resp) => {
          //
          console.log('saved .... ')
          this.configurationService.setClean();
          this.snackbar.open('Save successful.', '', { duration: 5000 });
          this.isLoading = false;
        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  public clearYear(): void {
    if (this.selectedYear == null || this.selectedYear === -1) {
      return;
    }

    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${this.selectedYear} non working days for ${this.selectedRegion.RegionName}?`).subscribe((result) => {
      if (result === true) {
        this.nonWorkingDaysService.deleteDaysByYear(this.selectedRegion.WorkRegionID, this.selectedYear).subscribe((val) => {
          this.configurationService.setClean();
          try {
            this.nonWorkingDaysService.getScheduleNonWorking(this.selectedRegion.WorkRegionID).subscribe((response) => {
              this.nonWorkingDays = new NonWorkingDaysModel(response.cfgScheduleNonWorkingDays);

              const defaultMinNumOfYearsToDisplay: number = 5;
              if (this.nonWorkingDays.ByYear.size < defaultMinNumOfYearsToDisplay) {
                const diff: number = defaultMinNumOfYearsToDisplay - this.nonWorkingDays.ByYear.size;

                for (let i = 0; i < diff; i++) {
                  this.nonWorkingDays.AddEmptyYear();
                }

                if (this.scheduler) {
                  this.schedulerDataSource = this.nonWorkingDays.toScheduleDataSource(this.selectedYear);
                  this.countryValue =  this.nonWorkingDays.enumCountryID;
                }
              }
            });
          } catch (exception) {
            console.log(exception);
          }
          /*const idx = this.regionList.findIndex(p => p.WorkRegionID === model.WorkRegionID);
          if (idx > -1) {
            this.regionList.splice(idx, 1);
            this.selectedRegion = this.regionList[0];
            const tvd = new RegionTableViewData();
            tvd.model = this.selectedRegion;
            this.refreshRegionTableView();
            this.onTdoRegionTableItemClick(new TdoTableEvent(tvd), true);
          }*/
        });
      } else {
        //
      }
    });

    /*const days: any[] = this.scheduler.instance.getDataSource().items();

    if (days.length !== 0) {
      days.forEach(o => {
        if (new Date(o.startDate).getFullYear() === this.selectedYear) {
          this.scheduler.instance.deleteAppointment(o);
        }
      });
    }*/
  }

  //#region This section is for overriding dx scheduler's default behavior
  public overrideAppointmentClick(e): void {
    if (e.appointmentData.recurrenceRule == null || e.appointmentData.recurrenceRule.trim() === '') {
      e.cancel = true;
    }
  }

  public overrideAppointmentDblClick(e): void {
    this.scheduler.instance.deleteAppointment(e.appointmentData);
    const idx = this.nonWorkingDays.cfgScheduleNonWorkingDays.findIndex(p => p === e.appointmentData.model);
    if (idx > -1) {
      this.nonWorkingDays.cfgScheduleNonWorkingDays.splice(idx, 1);
      this.configurationService.setDirty();
    }
    e.cancel = true;
  }

  public overrideAppointmentFormOpening(e): void {
    e.cancel = true;
  }

  public overrideCellClick(e) {
    if (!this.timeoutCellClick) {
      this.timeoutCellClick = setTimeout(() => this.timeoutCellClick = null, 300);
    }
    else {
      this.addNonWorkingDayOntoSchedule(e.cellData);
    }
    e.cancel = true;
  }

  private addNonWorkingDayOntoSchedule(cellData) {
    if (cellData == null || cellData.startDate == null) {
      return;
    }

    this.configurationService.setDirty();

    const newStartDate = new Date(cellData.startDate);
    const existingDay = this.scheduler
                          .instance
                          .getDataSource()
                          .items()
                          .some(o => new Date(o.startDate).getTime() === newStartDate.getTime());

    if (existingDay) {
      return;
    }

    if (newStartDate.getFullYear() < this.selectedYear || newStartDate.getFullYear() > this.selectedYear) {
      return;
    }

    const nonWorkingDayModel = new NonWorkingDayModel(null, this.selectedRegion.WorkRegionID, this.selectedYear, newStartDate);
    this.nonWorkingDays.cfgScheduleNonWorkingDays.push(nonWorkingDayModel);

    this.scheduler.instance.addAppointment({
      text: _nonWorkingDayTextLabel,
      startDate: cellData.startDate,
      endDate: cellData.endDate,
      allDay: true,
      model: nonWorkingDayModel
    });
  }
  //#endregion
}
